import { useCallback } from 'react';
import { getOptions } from 'helpers/getOptions';
import { useDispatch } from 'react-redux';
import {
  updateSheetAddResource,
} from 'store/schedule/schedulePageOperation';
import $api from 'http/index';

const useAddResources = () => {
  const dispatch = useDispatch();

  const addResource = useCallback(async ({ sheetId, resources }) => {
    const postData = !!resources.workers ? { workers: resources.workers } : { equipment: resources.equipment }
    const path = !!resources.workers ? 'workers' : 'equipment'
    const response = await $api.put(
      `${process.env.REACT_APP_BASE_URL}/sheets/${sheetId}/${path}`,
      postData,
      getOptions(),
    )

    dispatch(updateSheetAddResource(response.data._id, 1));
    return response.data;
  }, []);

  return { addResource };
};

export default useAddResources;